<div class="attendance-summary-column">
    <slot/>
</div>

<style lang="less">
    @import (reference) "styles/portaro.variables.less";
    @import (reference) "styles/portaro.themes.less";

    .attendance-summary-column {
        display: flex;
        flex-direction: column;
        flex: 1;
    }
</style>